import type { MusicType, Sound } from "@akina/domain";
import type { ApiConfiguration } from "./shared";
import type { CMSStory } from "../adapters";

export const soundApi = (config: ApiConfiguration) => ({
  async getSounds(type: Sound["type"]): Promise<Sound[]> {
    const response = await config.cmsService.get<{
      Description: string;
      URLLink: { url: string };
      MusicType?: MusicType;
      IsDisabled?: boolean;
    }>(config.cmsEndpoints.sound(type));
    const stories = response.data.stories;

    return stories.map((s: CMSStory<{ Description: string; URLLink: { url: string }; MusicType?: MusicType; IsDisabled?: boolean }>) => ({
      key: s.slug,
      name: s.content.Description,
      url: s.content.URLLink.url,
      type: type,
      musicType: s.content.MusicType,
      isDisabled: s.content.IsDisabled,
    }));
  },
  async getSoundByKey(type: Sound["type"], key: string): Promise<Sound | undefined> {
    const response = await config.cmsService.get<{
      Description: string;
      URLLink: { url: string };
      IsDisabled?: boolean;
    }>(`${config.cmsEndpoints.sound(type)}/${key}`);
    const story = response.data.stories[0];

    if (!story) return undefined;
    return {
      key: story.slug,
      name: story.content.Description,
      url: story.content.URLLink.url,
      type: type,
      isDisabled: story.content.IsDisabled,
    };
  },
});
